import { render, staticRenderFns } from "./ProfilePic.vue?vue&type=template&id=b79fdd78&scoped=true"
import script from "./ProfilePic.vue?vue&type=script&lang=ts"
export * from "./ProfilePic.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePic.vue?vue&type=style&index=0&id=b79fdd78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79fdd78",
  null
  
)

export default component.exports